import { render, staticRenderFns } from "./opcoes_pagamento.vue?vue&type=template&id=fd3a768e&scoped=true&"
import script from "./opcoes_pagamento.vue?vue&type=script&lang=js&"
export * from "./opcoes_pagamento.vue?vue&type=script&lang=js&"
import style0 from "./opcoes_pagamento.vue?vue&type=style&index=0&id=fd3a768e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3a768e",
  null
  
)

export default component.exports